import { Component, ChangeDetectionStrategy } from "@angular/core";

import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { IconComponent } from "@components/icon/icon.component";
import { InputComponent } from "@components/input/input.component";
import { LabelComponent } from "@components/label/label.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { ArbetsorderViol3ButtonComponent } from "../../../../../shared/components/arbetsorder-viol3-button/arbetsorder-viol3-button.component";
import { ExternArbetsorderDetailsComponent } from "../extern-arbetsorder-details.component";

@Component({
    selector: "rask-extern-arbetsorder-details-viol3",
    templateUrl: "./extern-arbetsorder-details-viol3.component.html",
    styleUrls: ["../extern-arbetsorder-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        InputComponent,
        FormsModule,
        SelectorComponent,
        LabelComponent,
        IconComponent,
        ListComponent,
        ListColumnDirective,
        CheckboxComponent,
        ArbetsorderViol3ButtonComponent,
        SaveButtonComponent,
        ButtonComponent,
        DatePipe
    ]
})
export class ExternArbetsorderDetailsViol3Component extends ExternArbetsorderDetailsComponent {
}
